import React from 'react';
import Slide, { ISlide } from '../../../../core/Slide';
import { CharacterDialogue } from '../../../../general/Character';
import { RangerJackSearch } from '../../characters/RangerJack';
import useFooterButtonRenderer from '../../../../misc/FooterButtonRenderer';
import { AbstractionData } from '../..';
import { t } from 'ttag';

const StormIntro3: React.FC<ISlide<AbstractionData>> = ({ nextSlide, defaultHeader, data }) => {
    const [footer, buttonRenderer] = useFooterButtonRenderer();

    const dialogue = [
        {
            character: RangerJackSearch,
            text: t`${data.name} it’s a disaster, the animals have escaped and got all mixed up! We need to get them back into the right enclosures. Quick! `,
            buttonText: t`I can help!`,
            buttonAction: nextSlide,
        },
    ];

    return (
        <Slide header={defaultHeader} footer={footer}>
            <CharacterDialogue dialogue={dialogue} buttonHandler={buttonRenderer} />
        </Slide>
    );
};

export default StormIntro3;
